export const INCOMPLETE_PROFILE_REMINDER_SESSION_KEY = 'onboardingReminderDismissed';

export const dismissIncompleteProfileReminderForSession = () => {
    sessionStorage.setItem(INCOMPLETE_PROFILE_REMINDER_SESSION_KEY, 'true');
};

export const getOnboardingStepName = (stepNumber) => {
    if (stepNumber === 1) return 'about';
    if (stepNumber === 2) return 'academics';
    if (stepNumber === 3) return 'work_preferences';

    return 'unknown';
};

export const getInitialOnboardingStep = (user) => {
    const step1Complete =
        !!String(user?.firstName || '').trim() &&
        !!String(user?.familyName || '').trim();

    const step2Complete =
        !!String(user?.currentDegree || '').trim() &&
        !!String(user?.currentEducationalInstitution || '').trim() &&
        !!String(user?.academicsCountry || '').trim() &&
        !!String(user?.academicsCity || '').trim() &&
        Array.isArray(user?.academicsStudyDirection) &&
        user.academicsStudyDirection.map(v => String(v || '').trim()).filter(Boolean).length > 0;

    const wp = user?.workPreferences || {};

    const countriesArr = Array.isArray(wp?.countriesWorkPreferences)
        ? wp.countriesWorkPreferences.map(v => String(v || '').trim()).filter(Boolean)
        : Array.isArray(user?.countriesWorkPreferences)
            ? user.countriesWorkPreferences.map(v => String(v || '').trim()).filter(Boolean)
            : [];

    const citiesArr = Array.isArray(wp?.citiesWorkPreferences)
        ? wp.citiesWorkPreferences.map(v => String(v || '').trim()).filter(Boolean)
        : Array.isArray(user?.citiesWorkPreferences)
            ? user.citiesWorkPreferences.map(v => String(v || '').trim()).filter(Boolean)
            : [];

    const languagesArr = Array.isArray(wp?.languagesWorkPreferences)
        ? wp.languagesWorkPreferences.map(v => String(v || '').trim()).filter(Boolean)
        : Array.isArray(user?.languagesWorkPreferences)
            ? user.languagesWorkPreferences.map(v => String(v || '').trim()).filter(Boolean)
            : [];

    if (!step1Complete) return 1;
    if (!step2Complete) return 2;
    if (countriesArr.length === 0 || citiesArr.length === 0 || languagesArr.length === 0) return 3;

    return 1;
};
